import { ROUTES } from 'config/constants';

export const PLATFORM_ADMINISTRATOR_ROLE = 'Administrator';

export const LEGACY_ADMIN_GROUP = 'Admin';

export const PLATFORM_ADMIN_ROUTE_PREFIXES = [
  ROUTES.ADMIN_HOME,
  ROUTES.VERSION,
] as const;

export function isPlatformAdministrator(
  groups: string[] | undefined | null,
): boolean {
  if (!Array.isArray(groups) || groups.length === 0) {
    return false;
  }

  return (
    groups.includes(PLATFORM_ADMINISTRATOR_ROLE) ||
    groups.includes(LEGACY_ADMIN_GROUP)
  );
}

function normalizePathname(pathname: string): string {
  const path = String(pathname || '/');
  if (path.length > 1 && path.endsWith('/')) {
    return path.slice(0, -1);
  }
  return path;
}

function matchesRoutePrefix(pathname: string, prefix: string): boolean {
  const normalizedPath = normalizePathname(pathname);
  const normalizedPrefix = normalizePathname(prefix);

  if (normalizedPath === normalizedPrefix) {
    return true;
  }

  return normalizedPath.startsWith(`${normalizedPrefix}/`);
}

export function isPlatformAdminRoute(pathname: string): boolean {
  return PLATFORM_ADMIN_ROUTE_PREFIXES.some((prefix) =>
    matchesRoutePrefix(pathname, prefix),
  );
}

export function getPostLoginRouteForUser(groups: string[] | undefined): string {
  if (isPlatformAdministrator(groups)) {
    return ROUTES.ADMIN_HOME;
  }

  return ROUTES.HOME_PAGE;
}
